import script from "./FormColor.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormColor.vue?vue&type=script&setup=true&lang=ts"

import "./FormColor.vue?vue&type=style&index=0&id=330f0034&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-330f0034"]])

export default __exports__